import { useNavigation } from '@refinedev/core';

import { useSnackbar } from '@rrexpress/core';

import { BaseCreate } from '@/components/create';
import useContact from '@/modules/contact/application/contact';

import ContactForm from './form';

const ContactCreate = () => {
  const { list } = useNavigation();
  const { createContact, loadingCreate } = useContact();
  const { show } = useSnackbar();

  async function handleOnSubmit(val: any) {
    try {
      await createContact(val);
      list('contacts');
      show('Berhasil membuat kontak', 'success');
    } catch (error: any) {
      show(error.message, 'error');
    }
  }
  return (
    <div className="w-[50vw] flex m-auto justify-center">
      <BaseCreate
        title="Tambah Kontak"
        isLoading={loadingCreate}
      >
        <ContactForm
          onFinish={handleOnSubmit}
          type="create"
          initialValue={{}}
        />
      </BaseCreate>
    </div>
  );
};

export default ContactCreate;
